// extracted by extract-css-chunks-webpack-plugin
module.exports = {"text":"assessor-reject-caption__text--1ArPp"};